import React from 'react';
import MiCompAPI from '../../../util/api';
import { withRouter } from 'react-router-dom';
import { Layout, Form, Menu, Row, Col, Spin, message, Empty } from 'antd';
import img from '../../../assets/img/Illustratiion@3x.png';
import AgencyForm from './AgencyForm';
import BrokerForm from './BrokerForm';
import ClientForm from './ClientForm';
import Footer from '../../Layout/Footer';
import MemberForm from '../Member/MemberForm';

const {
  Header, Content,
} = Layout;
let add = false;
class RegistrationCompletion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formLoading: true,
      lob: [],
      states: [],
      data:null
    }
    
    if (this.props.type === "broker") {
      this.signUpForm = Form.create()(BrokerForm);
      this.postDataUrl = "PersonalDetailsUpdate";
      this.InvitationUrl = "GetBrokerById";
    }
    else if (this.props.type === 'carrier') {
      this.signUpForm = Form.create()(ClientForm);
      this.postDataUrl = "ClientDetailsUpdate";
      this.InvitationUrl = "GetClientDataById";
    }
    else if (this.props.type === "agency") {
      this.signUpForm = Form.create()(AgencyForm);
      this.postDataUrl = "AgencyDetailsUpdate";
      this.InvitationUrl = "GetAgencyById";
    }    
    else if (this.props.type === "member") {
      this.signUpForm = Form.create()(MemberForm);
      this.postDataUrl = "MemberAddressUpdate";
      this.InvitationUrl = "GetMemberbyUserId";
    }
    this.api = new MiCompAPI(null);
  }
  componentDidMount() {

    this.setState({
      formLoading: true,data:null
    })
    
    this.api.invoke(this.InvitationUrl + "/" + this.props.id, "get", (data, success) => {
      if (success) {
        this.setState({

          formLoading: false,
          data:data.data
        });
      }
    })
    this.getClientMasters();

  }
  getClientMasters() {

    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {
          this.setState({
            states: data.states,
            lob: data._lobs,
            formLoading: false
          });
        }
      },
      ["LOBS", "STATE"]
    );
  }
  handleSignUp = (values) => {
    const closeMessage = message.loading("Please wait while we prepare ourselves for you to onboard.", 0);
    this.api.invoke(this.postDataUrl, "post", (data, success) => {
      if (success) {
        closeMessage();
        this.props.RegistrationDone();
        message.success("Profile updated successfully ", 3).then(() => window.location.pathname = "");
      }
      else {
        closeMessage();
        message.error("Fatal error. Contact support.", 3);
      }
    }, values);
  }
  render() {
    
    const header = (<Header style={{ backgroundColor: '#f9f9fd', height: '80px', boxShadow: 'rgba(78, 86, 148, 0.35) 0px 0px 3px 3px' }}><div className="logo" style={{    marginTop: '28px'}} />
      <Menu
        theme="light"
        mode="horizontal"
        defaultSelectedKeys={['2']}
        style={{ lineHeight: '64px', height: '80px', backgroundColor:'#f9f9fd'}}
      >
        {/* <Menu.Item key=""> <span>Home </span></Menu.Item>
        <Menu.Item key="/about"><span>About </span></Menu.Item>
        <Menu.Item key="/help"><span>Help </span></Menu.Item> */}
      </Menu>
    </Header>);
    if (this.state.formLoading) {
      return (<Layout>
        {header}
        <Spin size="large" style={{ backgroundColor: 'white' }} />
      </Layout>)
    }
    else if (this.signUpForm) {
      return (
  
        <Layout style={{ backgroundColor: 'white' }}>
          {header}
          <Content style={{ margin: '50px auto', backgroundColor: 'white' }}>
            <div className="mi_main_inv"  >
              <div className="mi_box">
                <Row span={24}>
                  <Col span={15}>
                    <h4 className="mi_box_h4"><strong>Welcome</strong></h4>
                    <p className='mi_title2' style={{ color: 'white' }}>
                      Complete your profile for us to know you better.                               </p>
                  </Col>
                  <Col span={9}>
                    <img alt="example" style={{ height: '150px', marginTop: '-60px' }} src={img} />
                  </Col>
                </Row>
              </div>
              
              {this.state.data?
              <this.signUpForm lob={this.state.lob} states={this.state.states} data={this.state.data} isexistprofile={false} id={this.props.id} submitHandler={this.handleSignUp} />
              :""}
              </div>
          </Content>
          <Footer className="mi_footer>"></Footer>

        </Layout>
      );
    } else {
      return <Empty description="page not found" style={{ height: '277px', marginTop: '100px' }}></Empty>
    }
  }
}
let ex = withRouter(RegistrationCompletion);
if (!add)
  ex = RegistrationCompletion;
export default ex;